import React from 'react';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DISCOVERY_METRICS, DISCOVERY_QUERY_KEYS } from '../../utils/playerDiscovery';
import './playerDiscovery.css';

export default function PlayerDiscoveryControls({ params, filters, sources, sort, onChange, compact = false }) {
  const { t } = useTranslation('directories');
  const label = id => t(`discovery.metrics.${id}`);
  const changeRule = (index, values) => onChange({
    criteria: JSON.stringify(filters.criteria.map((rule, position) => position === index ? { ...rule, ...values } : rule)),
  });
  return <section className={`${compact ? '' : 'dr-panel '}pd-search`} aria-labelledby="player-discovery-title">
    <header className="dr-panel-header"><div>
      {!compact && <p className="pd-eyebrow">{t('discovery.eyebrow')}</p>}
      <h2 id="player-discovery-title">{t(compact ? 'discovery.filterAction' : 'discovery.title')}</h2>
      {!compact && <p className="dr-muted">{t('discovery.intro')}</p>}
    </div><Button onClick={() => onChange(Object.fromEntries(DISCOVERY_QUERY_KEYS.map(key => [key, null])))}>
      {t('discovery.clear')}
    </Button></header>
    <div className="pd-fields">
      {['minAge', 'maxAge', 'minMatches'].map(key => <label key={key}>{t(`discovery.${key}`)}
        <input type="number" min="0" step="1" value={params.get(key) || ''}
          onChange={event => onChange({ [key]: event.target.value })} />
      </label>)}
      <label>{t('discovery.primaryMetric')}<select value={sort.startsWith('d_') ? sort.slice(2) : ''}
        onChange={event => event.target.value && onChange({ sort: `d_${event.target.value}`, direction: 'desc' })}>
        <option value="">{t('discovery.existingOrder')}</option>
        <optgroup label={t('discovery.basic')}>{DISCOVERY_METRICS.filter(metric => !metric.advanced)
          .map(({ id }) => <option key={id} value={id}>{label(id)}</option>)}</optgroup>
        <optgroup label={t('discovery.advanced')}>{DISCOVERY_METRICS.filter(metric => metric.advanced)
          .map(({ id }) => <option key={id} value={id}>{label(id)}</option>)}</optgroup>
      </select></label>
    </div>
    <details className="pd-coverage" open={sources.length > 1 || undefined}>
      <summary>{t('discovery.coverageSettings')}</summary>
      <p className="dr-muted">{t('discovery.coverageHint')}</p>
      <div className="pd-fields">
        {sources.length > 1 && <label>{t('discovery.metricSource')}<select value={filters.source}
          onChange={event => onChange({ metricSource: event.target.value })}>
          <option value="">{t('discovery.chooseSource')}</option>
          {sources.map(source => <option key={source} value={source}>{source}</option>)}
        </select></label>}
        {['metricMinutes', 'metricMatches'].map(key => <label key={key}>{t(`discovery.${key}`)}
          <input type="number" min="0" step="1" value={params.get(key) || ''}
            onChange={event => onChange({ [key]: event.target.value })} />
        </label>)}
      </div>
    </details>
    <div className="pd-rules">
      {filters.criteria.map((rule, index) => <fieldset key={index} className="pd-rule">
        <legend>{t('discovery.condition', { number: index + 1 })}</legend>
        <label>{t('discovery.metric')}<select value={rule.metric || ''}
          onChange={event => changeRule(index, { metric: event.target.value })}>
          <option value="">{t('discovery.chooseMetric')}</option>
          {DISCOVERY_METRICS.map(({ id }) => <option key={id} value={id}>{label(id)}</option>)}
        </select></label>
        {['min', 'max'].map(key => <label key={key}>{t(`discovery.${key}`)}
          <input type="text" inputMode="decimal" value={rule[key] ?? ''}
            onChange={event => changeRule(index, { [key]: event.target.value })} />
        </label>)}
        <Button aria-label={t('discovery.removeCondition', { number: index + 1 })}
          onClick={() => onChange({ criteria: JSON.stringify(filters.criteria.filter((_, position) => position !== index)) })}>
          {t('discovery.remove')}
        </Button>
      </fieldset>)}
      <Button variant="outlined" disabled={filters.criteria.length >= 8 || filters.invalid}
        onClick={() => onChange({ criteria: JSON.stringify([...filters.criteria, { metric: 'nonPenaltyGoals90', min: '', max: '' }]) })}>
        {t('discovery.addCondition')}
      </Button>
    </div>
  </section>;
}
